// ============================================================================
// Buddy Trip Abuse — dedicated super-admin moderation page (route:
// /admin/buddy-abuse). Holds the cross-tenant Buddy-Trip moderation surfaces
// that used to live inline on the platform Overview:
//   • BuddyAbuseSuperAdminCard    — cross-tenant strike rollup
//   • BuddyAuditLogSuperAdminCard — full moderation audit log (CSV/PDF export)
// Moved out so the Overview stays a health-at-a-glance dashboard.
// ============================================================================

import { useEffect } from 'react';
import { usePlatformStore } from '@/lib/store';
import { BuddyAbuseSuperAdminCard } from '@/components/dashboard/BuddyAbuseAnalyticsCard';
import { BuddyAuditLogSuperAdminCard } from '@/components/dashboard/BuddyAuditLogCard';

export function BuddyAbusePage() {
  // The cross-tenant cards resolve tenant names from the store's tenants
  // list (id → name). On Overview that list was already loaded; on this
  // standalone page we must load it, else the Tenant dropdown + column
  // fall back to raw tenant IDs.
  const tenants = usePlatformStore(s => s.tenants);
  const loadTenants = usePlatformStore(s => s.loadTenants);
  useEffect(() => {
    if (tenants.length === 0) loadTenants();
  }, [tenants.length, loadTenants]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-surface-900">Buddy Trip Abuse</h1>
        <p className="text-surface-500 mt-1 text-sm">
          Cross-tenant Buddy-Trip moderation — the strike rollup plus the full
          moderation audit log (CSV / PDF export for legal review).
        </p>
      </div>

      <BuddyAbuseSuperAdminCard />
      <BuddyAuditLogSuperAdminCard />
    </div>
  );
}
